export enum ConsoleUserRole {
  super_admin,
  admin,
  support,
  analytics,
  producer
}
